import $ from 'jquery'
import _ from 'underscore'

const AGENT_BADGE_SVG = '<svg class="agent-badge__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 28" fill="none">'
  + '<line x1="12" y1="2" x2="12" y2="5" stroke="#888" stroke-width="1.5" stroke-linecap="round"/>'
  + '<circle cx="12" cy="1.5" r="1.5" fill="#888"/>'
  + '<rect x="4" y="5" width="16" height="16" rx="3" fill="#888"/>'
  + '<circle cx="9" cy="12.5" r="2" fill="#fff"/><circle cx="15" cy="12.5" r="2" fill="#fff"/>'
  + '<path d="M9 17 Q12 19 15 17" stroke="#fff" stroke-width="1.2" stroke-linecap="round" fill="none"/>'
  + '<rect x="1" y="10.5" width="2.5" height="5" rx="1" fill="#888"/>'
  + '<rect x="20.5" y="10.5" width="2.5" height="5" rx="1" fill="#888"/></svg>'

function triggerChange(e) {
  $(e.target).trigger('change')
}

function renderPersonItem(ul, item) {
  const badge = item.kind === 'agent'
    ? ` ${AGENT_BADGE_SVG}`
    : ''
  return $('<li>')
    .append(`<div>${$.fn.jquery ? $('<span>').text(item.label).html() : item.label}${badge}</div>`)
    .appendTo(ul)
}

_(gf).extend({
  setupAutocomplete() {
    $('[data-gf-autocomplete]').each(function () {
      const instance = $(this).autocomplete({
        source: $(this).data('gf-autocomplete'),
        appendTo: 'body',
        change: triggerChange,
        select: triggerChange,
      })
      // eslint-disable-next-line no-underscore-dangle
      instance.autocomplete('instance')._renderItem = renderPersonItem
    })
    $('[data-gf-triggered-autocomplete]').each(function () {
      $(this).triggeredAutocomplete({
        source: $(this).data('gf-triggered-autocomplete'),
        trigger: '@',
        appendTo: 'body',
        change: triggerChange,
        select: triggerChange,
      })
    })
    $('[data-gf-simple-triggered-autocomplete]').each(function () {
      $(this).triggeredAutocomplete({
        source: $(this).data('gf-simple-triggered-autocomplete'),
        trigger: '@',
        appendTo: 'body',
        change: triggerChange,
      })
    })
  },
})

$(document).ready(gf.setupAutocomplete)
  .on('dialogopen', gf.setupAutocomplete)
  .on('ajax:success', gf.setupAutocomplete)
